import React from "react";
import { Modal, Button, ModalHeader, ModalFooter, ModalBody } from "react-bootstrap";

const AmendmentWarning = ({ show, onClose, onProceed, preparedByName }) => {
  return (
    <Modal centered backdrop="static" show={show} onHide={onClose}>
      <ModalHeader>
        <div style={{ display: "flex", alignItems: "center", fontWeight: "bold", fontSize: "20px", flexGrow: 1 }}>
          <i style={{ fontSize: "30px", marginRight: "10px" }} className="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
          <span>Warning</span>
        </div>
        <Button 
          variant="light" 
          onClick={onClose} 
          style={{ fontSize: "30px", position: "absolute", top: "0px", right: "10px", border: "none", background: "transparent" }}
          aria-label="Close"
        >
          &times; 
        </Button>
      </ModalHeader>
      <ModalBody className="text-danger">
      Booking is under prepared by: <strong className="text-danger">{preparedByName}</strong>
      <div className="mt-2">Please call to attention before any amendments.</div></ModalBody>
      <ModalFooter>
       
        <Button variant="primary" onClick={onProceed}>
          Proceed
        </Button>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AmendmentWarning;